import { render, staticRenderFns } from "./reports_page.vue?vue&type=template&id=3cd52146&scoped=true"
import script from "./reports_page.vue?vue&type=script&lang=js"
export * from "./reports_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd52146",
  null
  
)

export default component.exports